import './style/index.js';

import _Transfer from './Transfer';

export type { TransferProps } from './Transfer';
export * from './type';

export const Transfer = _Transfer;
export default Transfer;
